import { Inject, Injectable, Optional } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import moment from 'moment';

@Injectable()
export class DynamicDateAdapter extends MomentDateAdapter {
    private _dynamicFormat: string = 'MM/DD/YYYY';

    constructor(
        @Optional() @Inject(MAT_DATE_LOCALE) dateLocale: string
    ) {
        super(dateLocale);
    }


    setDynamicFormat(format: string) {
        this._dynamicFormat = format;
    }

    setDynamicLocale(locale: string) {
        this.setLocale(locale);  // use base class method to set locale
    }

    override parse(value: any, parseFormat?: string | string[]): moment.Moment | null {
        if (typeof value === 'string' && value.length > 0) {
            const format = this._dynamicFormat || (parseFormat as string);
            const m = moment(value, format, true);
            return m.isValid() ? m : null;
        }
        return value ? moment(value) : null;
    }

    override format(date: moment.Moment, displayFormat: string): string {
        if (!date || !date.isValid()) return '';
        return date.format(this._dynamicFormat || displayFormat);
    }

}
